module.exports = __webpack_public_path__ + "static/media/masterCard.005dac45.png";